import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { useCurrentAccountId } from '@zapier/design-system-revenue/src/hooks';
import { accountHasReachedTaskLimit } from '@zapier/design-system-revenue/src/utils';

import { upgradeModal_currentAccount as CurrentAccountData } from './types/upgradeModal_currentAccount';

export const currentAccountQuery = gql`
  query upgradeModal_currentAccount($accountId: Int!) {
    account(id: $accountId) {
      id
      plan: planV2 {
        hasMeteredBilling
        id
      }
      showTaskUpgradeNudge
      taskBufferOverride
      usage {
        tasks {
          total
          limit
        }
      }
    }
  }
`;

export const useCurrentAccount = () => {
  const { accountId } = useCurrentAccountId();

  const { data, error, loading } = useQuery<CurrentAccountData>(
    currentAccountQuery,
    {
      skip: !accountId,
      variables: {
        accountId,
      },
    }
  );

  const account = data?.account;

  const hasReachedTaskLimit = accountHasReachedTaskLimit({
    taskBufferMultiplier: account?.taskBufferOverride ?? 1,
    taskLimit: account?.usage?.tasks?.limit ?? 0,
    tasksUsed: account?.usage?.tasks?.total ?? 0,
  });

  return {
    error: error
      ? 'There was an error fetching account information. Please try again.'
      : null,
    isLoading: loading,
    showTaskUpgradeNudge:
      account?.showTaskUpgradeNudge &&
      hasReachedTaskLimit &&
      !account?.plan?.hasMeteredBilling,
  };
};
